export const mobileCommon = {
  "common.no-access.title": "No Access",
  "common.no-access.message": "You do not have permission to view or edit this content.",
};

